'use client';

import { useEffect, useMemo } from 'react';
import { useStoreSetFetch } from './store';
import { makeFetchWithGuestMint } from '@/lib/api/fetch-with-guest-mint';

/**
 * Non-visual bridge that wires the guest-mint wrapped fetch into the workspace
 * store. After this mounts, any store `fetchJSON` mutation that gets the
 * structured 401 from an anon session mints an ephemeral guest (cloning the
 * current workspace) and navigates to the clone. No-op once the visitor has a
 * session (human or guest), so it's safe to mount unconditionally.
 */
export function StoreSignupGateBridge() {
  const setFetch = useStoreSetFetch();
  const wrapped = useMemo(() => makeFetchWithGuestMint(), []);
  useEffect(() => {
    setFetch(wrapped);
  }, [wrapped, setFetch]);
  return null;
}
